import { atom } from 'jotai';

export const sidebarVisibleAtom = atom<boolean>(false);
